<div class="page-layout-container">
  <div class="row">
    <h1 class="title">Contracts Report</h1>
  </div>

  <!-- ROW-1 OPEN -->
  <div class="row">
    <div class="col-xl-12 col-md-12">
      <div class="card cart">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-bordered border-bottom text-nowrap">
              <thead>
                <tr class="border-top">
                  <th class="w-5">Employee Name</th>
                  <th class="w-5">Contract ID</th>
                  <th class="w-15">Client Name</th>
                  <th class="w-10">Max allowed Days/Hours</th>
                  <th class="w-10">Days/Hours worked So far</th>
                  <th class="w-10">Remaning Days/Hours</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let items of contractData">
                  <td>{{ items.empName }}</td>
                  <td>{{ items.contractId }}</td>
                  <td>{{ items.clientName }}</td>
                  <td>{{ items.contractDays }}</td>
                  <td>{{ items.daysWorked }}</td>
                  <td>{{ items.availableDays }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="float-end">
            <ngb-pagination
              [collectionSize]="40"
              [page]="1"
              aria-label="Default pagination"
            ></ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ROW-1 CLOSED -->
</div>
